import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error not migrated to TS
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import { track } from '../../common/eventTracking/tracker';
import { submitAdditionalPqlForm } from '../../pql/submitPql';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { MODAL_TYPES } from '../constants';
import { CallConfirmationSection } from './CallConfirmationSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CenteredContent = styled.div.withConfig({
  displayName: "GetACallSection__CenteredContent",
  componentId: "i91exg-0"
})(["text-align:center;"]);
const StyledPhoneInput = styled(PhoneNumberInput)(({
  theme
}) => ({
  width: '100%',
  marginBottom: theme.space['600']
}));
export const GetACallSection = ({
  handleIframeSizeChange,
  onBackClick,
  upgradeData,
  repInfo,
  setShowGetACallTitle
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneNumberSubmitted, setIsPhoneNumberSubmitted] = useState(false);
  const handleSubmit = () => {
    void submitAdditionalPqlForm(Object.assign({}, upgradeData, {
      isAssignable: true,
      isRetail: false,
      repInfo
    }), {
      phoneNumber
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'submitted phone number',
      repName: getRepName(repInfo)
    }, getUpgradeDataTrackingProperties(upgradeData)));
    handleIframeSizeChange(MODAL_TYPES.PHONE_NUMBER_SUBMITTED);
    setIsPhoneNumberSubmitted(true);
    setShowGetACallTitle(false);
  };
  if (isPhoneNumberSubmitted) {
    return /*#__PURE__*/_jsx(CallConfirmationSection, {});
  }
  const handleInputChange = ({
    phoneNumber: phoneNumberValue
  }) => {
    setPhoneNumber(phoneNumberValue);
  };
  return /*#__PURE__*/_jsx(CenteredContent, {
    "data-test-id": "communication-selected-method-call",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(StyledPhoneInput, {
        defaultValue: phoneNumber,
        value: phoneNumber,
        onChange: handleInputChange,
        "data-test-id": "phone-number-input"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleSubmit,
        use: "primary",
        disabled: !phoneNumber,
        "data-test-id": "submit-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.callButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "communication-call-back-button",
        use: "link",
        onClick: () => onBackClick(),
        marginBlockStart: '400',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.backButton"
        })
      })]
    })
  });
};